import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TouchScrollable } from 'react-scrolllock';
import CloudImg from '../CloudImg';
import { premiumMessagePriceVat } from '../../utils/variables';
import ButtonWithPrice from '../ButtonWithPrice/ButtonWithPrice';
import { FormattedMessage, FormattedPlural } from 'react-intl';
import styles from './MessageDesignPicker.module.scss';
import Lightbox from 'react-image-lightbox';
import getCloudImgLink, { IMGIX_URL } from '../../utils/getCloudImgLink';
export default class MessageDesignPicker extends Component {
    constructor() {
        super();
        this.state = {
            design: null,
            gallery: [],
            currentImage: 0,
            isGalleryOpen: false
        };
    }

    componentDidMount() {
        if (this.props.selectedDesign !== '') {
            this.props.availableMessageDesigns.map((design, index) => {
                if (
                    design.title === this.props.selectedDesign ||
                    design.id === this.props.selectedDesign
                ) {
                    this.setState({ design: index });
                }
            });
        }
    }
    openGallery(index) {
        const messageDesign = this.props.availableMessageDesigns[index];

        const gallery = messageDesign.images.map(image => {
            return {
                mainSrc: getCloudImgLink(image, 'jpg', 800),
                thumbSrc: getCloudImgLink(image, 'jpg', 100)
            };
        });

        this.setState({
            gallery: gallery,
            currentImage: 0,
            isGalleryOpen: true
        });
    }

    handleLightboxClose = () => {
        this.setState({
            gallery: [],
            currentImage: 0,
            isGalleryOpen: false
        });
    };

    handleDesignClick(designId) {
        this.setState({ design: designId });
        const designs = this.props.availableMessageDesigns;
        if (designId === null) {
            this.props.onDesignSelected('');
        } else {
            this.props.onDesignSelected(designs[designId].id, designs[designId].isPremium);
        }
    }

    renderLightBox() {
        const { isGalleryOpen, gallery, currentImage } = this.state;
        if (!isGalleryOpen) return null;

        return (
            <Lightbox
                onCloseRequest={this.handleLightboxClose}
                mainSrc={gallery[currentImage].mainSrc}
                nextSrc={gallery[(currentImage + 1) % gallery.length].mainSrc}
                prevSrc={gallery[(currentImage + gallery.length - 1) % gallery.length].mainSrc}
                mainSrcThumbnail={gallery[currentImage].thumbSrc}
                nextSrcThumbnail={gallery[(currentImage + 1) % gallery.length].thumbSrc}
                prevSrcThumbnail={
                    gallery[(currentImage + gallery.length - 1) % gallery.length].thumbSrc
                }
                onMovePrevRequest={() =>
                    this.setState({
                        currentImage: (currentImage + gallery.length - 1) % gallery.length
                    })
                }
                onMoveNextRequest={() =>
                    this.setState({
                        currentImage: (currentImage + 1) % gallery.length
                    })
                }
            />
        );
    }

    renderDesignList() {
        return this.props.availableMessageDesigns.map((design, index) => {
            const imageName = design.thumb.split('.')[0];
            const imageFormat = design.thumb.split('.')[1];
            return (
                <div className={styles.item} key={design.id}>
                    <div
                        className="message-design-thumb"
                        onClick={() => this.openGallery(index)}
                        style={{ cursor: 'pointer' }}
                    >
                        {imageFormat === 'gif' ? (
                            <img
                                src={`${IMGIX_URL}${imageName}.${imageFormat}`}
                                width={400}
                                height={400}
                                className="img-responsive space-b-sm"
                            />
                        ) : (
                            <CloudImg
                                imageId={imageName}
                                format={imageFormat}
                                width={400}
                                height={400}
                                class="img-responsive space-b-sm"
                            />
                        )}
                        <h4 className="message-design-title">{design.title}</h4>
                        <p className="message-design-note">
                            {design.isPremium ? (
                                <FormattedMessage
                                    defaultMessage="Váš text či fotka uvnitř"
                                    id={'messageDesignPicker.premiumLabel'}
                                />
                            ) : (
                                <FormattedMessage
                                    defaultMessage="Váš text na přední straně"
                                    id={'messageDesignPicker.freeLabel'}
                                />
                            )}
                        </p>
                    </div>
                    <div>
                        <ButtonWithPrice
                            onButtonClick={() => {
                                this.handleDesignClick(index);
                            }}
                            label={<FormattedMessage defaultMessage="Přidat" id={'global.add'} />}
                            price={
                                design.isPremium ? premiumMessagePriceVat[this.props.currency] : 0
                            }
                        />
                    </div>
                </div>
            );
        });
    }

    render() {
        return (
            <div className={styles.wrapper}>
                <h2 className={styles.title}>
                    <FormattedMessage
                        id="messageDesignPicker.title"
                        defaultMessage="Chcete do balíčku vlastní vzkaz?"
                    />
                </h2>
                <TouchScrollable>
                    <div className={styles.grid}>{this.renderDesignList()}</div>
                </TouchScrollable>
                <div className={styles.fixed}>
                    {' '}
                    <button onClick={this.props.onClose} className={'btn btn-confirm btn'}>
                        Pokračovat bez přáníčka
                    </button>
                </div>
                {this.renderLightBox()}
            </div>
        );
    }
}
MessageDesignPicker.propTypes = {
    availableMessageDesigns: PropTypes.array,
    currency: PropTypes.string,
    onClose: PropTypes.func,
    onDesignSelected: PropTypes.func,
    selectedDesign: PropTypes.string
};
